import cx from "classnames";
import React from "react";
import style from "./EndVote.module.css";

export function EndVote({ endHandler, closeModal }) {
    return (
        <div className={style.modal}>
            <div className={style.header}>
                <p className={style.title}>Завершить голосование?</p>
                <button
                    onClick={closeModal}
                    className={cx(style.close, style.button, "button--close")}
                    type="button"
                    aria-label="Закрыть"
                />
            </div>

            <p className={style.description}>Возможно не все проголосовали</p>
            <div className={style.buttons}>
                <button
                    onClick={() => endHandler()}
                    className={style.complete}
                    aria-label="Завершить"
                    type="button"
                >
                    Завершить
                </button>
                <button
                    onClick={() => closeModal()}
                    className={style.back}
                    aria-label="Вернуться"
                    type="button"
                >
                    Вернуться
                </button>
            </div>
        </div>
    );
}
